<template lang="html">
<div class="material-content-model" :id="'material-content-model' + _uid" :style="boxStyle" :class="source == 3 ? 'self-material' : ''">
  <!-- 文本类型素材 -->
  <div class="text-info" v-if="parseType == 1">
    <span v-for="text in textData" class="text-info-content">
      <span v-if="text.type === 'string'" v-katex="text.content"></span>
      <span v-if="text.type === 'mp3'">
        <audio-model :audioSrc="text.content"></audio-model>
      </span>
    </span>
  </div>
  <!-- roleplay -->
  <div class="json-info roleplay-info" v-if="parseType == 2">
    <ul>
      <li v-for="talk in jsonData">
        <img class="head" :src="talk.img" v-if="talk.img">
        <span class="head default-avator" v-else>{{talk.name.slice(0, 2)}}</span>
        <span class="role-name">{{talk.name}}:</span>
        <span class="role-speak" >
          <span class="role-speak-info" v-katex="talk.text"></span>
          <span class="audio-model-box" v-if="talk.audioSrc">
            <audio-model :audioSrc="talk.audioSrc"></audio-model>
          </span>
          <span v-else>{{talk.audioName}}</span>
        </span>
      </li>
    </ul>
  </div>
  <!-- 语音小导游 -->
  <div class="json-info tour-info" v-if="parseType == 3">
    <div class="bgmusic clearfix">
      <span class="tips">背景音乐：</span>
      <span v-for="music in tourData.bgMusic" class="text-info-content">
        <span v-if="music.type === 'string'" v-katex="music.content"></span>
        <span v-if="music.type === 'mp3'">
          <audio-model :audioSrc="music.content"></audio-model>
        </span>
      </span>
    </div>
    <div>
      <span class="tips">内容列表：</span>
      <ul class="content-list">
        <li class="content-item" v-for="content in tourData.contents">
          <div class="img-info info">
            <span class="tips">图片：</span>
            <span v-katex="content.pic"></span>
          </div>
          <div class="keyword info">
            <span class="tips">关键词：</span>
            <span class="keyword-content" v-text="content.keywords"></span>
          </div>
          <div class="words info clearfix">
            <span class="tips">内容：</span>
            <span class="words-content">
              <span v-for="word in content.words">
                <span v-if="word.type === 'string'" v-katex="word.content"></span>
                <span v-if="word.type === 'mp3'">
                  <audio-model :audioSrc="word.content"></audio-model>
                </span>
              </span>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <div class="demomusic clearfix">
      <span class="tips">示范音频：</span>
      <span v-for="music in tourData.demoMusic">
        <span v-if="music.type === 'string'" v-katex="music.content"></span>
        <span v-if="music.type === 'mp3'">
          <audio-model :audioSrc="music.content"></audio-model>
        </span>
      </span>
    </div>
  </div>

  <!-- AI老师 -->
  <div class="ai-info json-info" v-if="parseType == 4">
    <div class="ai-model">
      <strong class="title">模型</strong>
      <ul class="ai-model-list">
        <li v-for="model in AIData.modelInfo">
          <img v-if="model.path" :src="model.path" alt="模型图片"/>
          <strong v-else v-text="model.name"></strong>
        </li>
      </ul>
    </div>
    <div class="ai-question">
      <strong class="title">提问</strong>
      <ul>
        <li v-for="question in AIData.contents">
          <p class="ai-word">
            <span v-for="word in question.word">
              <!--  -->
              <span v-if="word.type === 'string'" v-katex="word.content"></span>
              <span v-if="word.type === 'mp3'">
                <audio-model :audioSrc="word.content"></audio-model>
              </span>
            </span>
          </p>
          <div class="question-fun-box">
            <div class="ai-question-audio">
              <span v-for="music in question.audio">
                <!--  -->
                <span v-if="music.type === 'string'" v-katex="music.content"></span>
                <span v-if="music.type === 'mp3'">
                  <audio-model :audioSrc="music.content"></audio-model>
                </span>
              </span>
            </div>
            <div class="ai-expression" v-if="question.expression.path || question.expression.name">
              <img v-if="question.expression.path" :src="question.expression.path" alt="表情图片"/>
              <strong v-else v-text="question.expression.name"></strong>
            </div>
            <div class="ai-action" v-if="question.action.path || question.action.name">
              <img v-if="question.action.path" :src="question.action.path" alt="动作图片"/>
              <strong v-else v-text="question.action.name"></strong>
            </div>
            <div class="ai-gif" v-if="question.gif && question.gif.name">
              <strong v-text="question.gif.name"></strong>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="ai-qustion-img">
      <strong class="title">提问图片</strong>
      <div v-katex="AIData.img" v-if="AIData.img" class="content"></div>
    </div>
    <div class="ai-follow">
      <strong class="title">提问后续</strong>
      <ul class="follow-list">
        <li v-for="follow in AIData.followup">
          <div class="ai-expression" v-if="follow.expression.path || follow.expression.name">
            <img v-if="follow.expression.path" :src="follow.expression.path" alt="表情图片"/>
            <strong v-else v-text="follow.expression.name"></strong>
          </div>
          <div class="ai-action" v-if="follow.action.path || follow.action.name">
            <img v-if="follow.action.path" :src="follow.action.path" alt="动作图片"/>
            <strong v-else v-text="follow.action.name"></strong>
          </div>
          <div class="ai-gif" v-if="follow.gif && follow.gif.name">
            <strong v-text="follow.gif.name"></strong>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- 小小演说家 -->
  <div class="json-info speech-info " v-if="parseType == 5">
    <span class="tips">标准素材：</span>
    <div class="text-info">
      <span v-for="text in speechData.content" class="text-info-content">
        <span v-if="text.type === 'string'" v-katex="text.content"></span>
        <span v-if="text.type === 'mp3'">
          <audio-model :audioSrc="text.content"></audio-model>
        </span>
      </span>
    </div>
    <div class="speech-keywords">
      <span class="tips">关键词：</span>
      <ul class="content-list">
        <li class="content-item" v-for="keyword in speechData.keywords">
          <div class="keywords">
            <span class="tips">关键词：</span>
            <span class="info">{{keyword.keywords}}</span>
          </div>
          <div class="weight">
            <span class="tips">权重：</span>
            <span class="info">{{keyword.weight}}</span>
          </div>
        </li>
      </ul>
    </div>
    <span class="tips">解析：</span>
    <div class="text-info">
      <span v-for="text in speechData.analytic" class="text-info-content">
        <span v-if="text.type === 'string'" v-katex="text.content"></span>
        <span v-if="text.type === 'mp3'">
          <audio-model :audioSrc="text.content"></audio-model>
        </span>
      </span>
    </div>
  </div>

  <!-- 音频讲解 -->
  <div class="json-info audio-explain-info" v-if="parseType == 6">
    <div>
      <span class="tips">音频讲解：</span>
      <ul class="content-list">
        <li class="content-item" v-for="content in audioExplainData">
          <div class="info">
            <span class="tips">音频：</span>
            <span v-for="music in content">
              <span v-if="music.type === 'string'" v-katex="music.content"></span>
              <span v-if="music.type === 'mp3'">
                <audio-model :audioSrc="music.content"></audio-model>
              </span>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- 图音讲解 -->
  <div class="json-info picture-audio-explain-info" v-if="parseType == 7">
    <div>
      <span class="tips">图音讲解：</span>
      <ul class="content-list">
        <li class="content-item" v-for="content in pictureAudioExplainData">
          <div class="img-info info">
            <span class="tips">图片：</span>
            <span v-katex="content.img"></span>
          </div>
          <div class="info">
            <span class="tips">音频：</span>
            <span v-for="music in content.audio">
              <span v-if="music.type === 'string'" v-katex="music.content"></span>
              <span v-if="music.type === 'mp3'">
                <audio-model :audioSrc="music.content"></audio-model>
              </span>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- 文音讲解 -->
  <!-- textAudioExplainData -->
  <div class="json-info text-audio-explain-info" v-if="parseType == 8">
    <div>
      <span class="tips">文音讲解：</span>
      <ul class="content-list">
        <li class="content-item" v-for="content in textAudioExplainData">
          <div class="words info clearfix">
            <span class="tips">内容：</span>
            <span class="words-content">
              <span v-for="text in content.text">
                <span v-if="text.type === 'string'" v-katex="text.content"></span>
                <span v-if="text.type === 'mp3'">
                  <audio-model :audioSrc="text.content"></audio-model>
                </span>
              </span>
            </span>
          </div>
          <div class="info">
            <span class="tips">音频：</span>
            <span v-for="music in content.audio">
              <span v-if="music.type === 'string'" v-katex="music.content"></span>
              <span v-if="music.type === 'mp3'">
                <audio-model :audioSrc="music.content"></audio-model>
              </span>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
import styleMixin from 'xes-frontend-ui/src/mixins/styleMixin'
import { latexToHtml } from '../utils/latex.js'
import AudioModel from './audio'

export default {
  name: 'xes-material-content',
  props: {
    source: {
      type: String,
      default: ''
    },
    height: [String, Number],
    width: [String, Number],
    content: {
      type: String,
      default: ''
    },
    resource: {
      type: Object,
      default () {
        return {}
      }
    },
    parseType: {
      type: [String, Number],
      default: '1'
    }
  },
  mixins: [styleMixin],
  components: {
    AudioModel
  },
  watch: {
    // 监听内容变化
    content (val) {
      if (!val) return
      // 处理内容数据
      clearInterval(this.handleTimer)
      this.handleTimer = setTimeout(() => {
        this.handleData()
      }, 100)
    },
    resource (val) {
      if (typeof val === 'object' && val) {
        clearInterval(this.handleTimer)
        this.handleTimer = setTimeout(() => {
          this.handleData()
        }, 110)
      }
    },
    parseType (val) {
      if (val) {
        clearInterval(this.handleTimer)
        this.handleTimer = setTimeout(() => {
          this.handleData()
        }, 120)
      }
    }
  },
  data () {
    return {
      textData: [],
      jsonData: [],
      tourData: {},
      AIData: {},
      speechData: {},
      audioExplainData: [],
      pictureAudioExplainData: [],
      textAudioExplainData: [],
      handleTimer: null
    }
  },
  mounted () {
    this.handleData()
  },
  methods: {
    handleData () {
      if (this.parseType == 2) {
        // rolePlay类型
        this.initRolePlayData()
      } else if (this.parseType == 3) {
        // 语音小导游类型
        this.initTourData()
      } else if (this.parseType == 4) {
        // ai老师类型
        this.initAIData()
      } else if (this.parseType == 5) {
        // 演说家类型
        this.initSpeechData()
      } else if (this.parseType == 6) {
        this.initAudioExplainData()
      } else if (this.parseType == 7) {
        this.initPictureAudioExplainData()
      } else if (this.parseType == 8) {
        this.initTextAudioExplainData()
      } else {
        // 文本类型
        this.initTextData()
      }
    },
    // 文本替换图片ubb
    changeImg (data) {
      let pattern = new RegExp('\\[img=([^\\[|^\\]]*)\\]', 'g')
      let neededData = data.replace(pattern, ($1, $2) => {
        let src = ''
        for (let key in this.resource) {
          if (key == $2) {
            src = this.resource[key]
          }
        }
        if (src) {
          return '<img src=' + src + '>'
        } else {
          return $1
        }
      })
      return neededData
    },
    // 文本替换音频ubb
    changeAudio (content) {
      if (content === '') return []
      let reg = /\[audio=.*?\.mp3\]/g
      let txtArr = content.split(reg)
      let mp3Arr = content.match(reg)
      let arr = []
      txtArr.forEach((el, index) => {
        el.length && arr.push({ type: 'string', content: el })
        if (index != txtArr.length - 1) {
          const mp3Name = mp3Arr[index].split('=')[1].replace(']', '')
          const mp3URL = this.resource[mp3Name]
          // 资源中找到匹配项，返回mp3。否则返回文本，内容为音频ubb
          if (mp3URL) {
            arr.push({ type: 'mp3', content: mp3URL })
          } else {
            arr.push({ type: 'string', content: mp3Arr[index] })
          }
        }
      })
      return arr
    },
    initTextData () {
      let htmlData = latexToHtml(this.content, undefined, 'pt')

      // 替换图片标签
      htmlData = this.changeImg(htmlData)

      // 替换audio标签
      htmlData = this.changeAudio(htmlData)
      this.textData = htmlData
    },
    initRolePlayData () {
      let content
      try {
        content = JSON.parse(this.content)[0]
      } catch (e) {
        console.log('JSON解析出错')
      }
      if (!content) return
      const roles = content.roles
      const speeches = content.speeches
      this.jsonData = speeches.map(item => {
        const role = roles.find(role => role.role == item.role)
        const data = {
          name: role.name,
          img: role.img,
          text: item.text
        }
        // 若对话中有图片或者语音
        // 获取图片资源
        let pattern = new RegExp('\\[img=([^\\[]*)\\]', 'g')
        data.text = data.text.replace(pattern, ($1, $2) => {
          let src = ''
          for (let key in this.resource) {
            if (key == $2) {
              src = this.resource[key]
            }
          }
          if (src) {
            return '<img class="img" src=' + src + '>'
          } else {
            return $1
          }
        })
        // 获取语音资源
        const audioName = item.audio
        if (audioName) {
          data.audioSrc = this.resource[item.audio]
          data.audioName = `[audio=${audioName}]`
        }
        return data
      })
    },
    // 处理语音小导游数据
    initTourData () {
      let content
      try {
        content = JSON.parse(this.content)[0]
      } catch (e) {
        console.log('JSON解析出错')
      }
      if (!content) return
      // 处理背景音乐
      const bgMusic = this.changeAudio(content.bgmusic)
      // 处理示范音频
      const demoMusic = this.changeAudio(content.demomusic)
      // 处理内容列表
      const contents = content.contents.map(item => {
        // 处理pic,替换图片ubb
        const pic = this.changeImg(item.pic)
        // 处理关键词
        const keywords = item.keywords.replace(/\|\|/g, '， ')
        // 处理words，替换图片及音频ubb
        let words = this.changeImg(item.words)
        words = this.changeAudio(words)
        return {
          pic,
          keywords,
          words
        }
      })
      this.tourData = {
        bgMusic,
        demoMusic,
        contents
      }
    },
    // AI老师类型数据处理
    initAIData () {
      let content
      try {
        content = JSON.parse(this.content)[0]
      } catch (e) {
        console.log('JSON解析出错')
      }
      if (!content) return
      // 处理提问图片ubb
      content.img = this.changeImg(content.img) || ''
      content.contents = content.contents.map(item => {
        // 处理提问中audio中的音频ubb
        let audioReg = new RegExp('\\[audio=([^\\[|^\\]]*)\\]', 'g')
        item.audio = this.changeAudio(item.audio)
        // 处理提问word中的音频ubb
        item.word = this.changeAudio(item.word)
        return item
      })
      this.AIData = content
    },
    // 演说家类型数据处理
    initSpeechData () {
      let content
      try {
        content = JSON.parse(this.content)[0]
      } catch (e) {
        console.log('JSON解析出错')
      }
      if (!content) return

      // 处理标准素材展示、处理解析展示
      let htmlData = latexToHtml(content.content, undefined, 'pt')
      let analytic = latexToHtml(content.analytic, undefined, 'pt')
      // 替换图片标签
      htmlData = this.changeImg(htmlData)
      analytic = this.changeImg(analytic)
      // 替换audio标签
      htmlData = this.changeAudio(htmlData)
      analytic = this.changeAudio(analytic)
      this.speechData = {
        content: htmlData,
        keywords: content.keywords,
        analytic
      }
    },
    // 音频讲解类型数据处理
    initAudioExplainData () {
      let content
      try {
        content = JSON.parse(this.content)
      } catch (e) {
        console.log('JSON解析出错')
      }
      if (!content) return
      this.audioExplainData = content.map(item => {
        // 处理音频
        return this.changeAudio(item)
      })
    },
    // 图音讲解类型数据处理
    initPictureAudioExplainData () {
      let content
      try {
        content = JSON.parse(this.content)
      } catch (e) {
        console.log('JSON解析出错')
      }
      if (!content) return
      this.pictureAudioExplainData = content.map(item => {
        // 处理img
        const img = this.changeImg(item.img)
        // 处理audio
        const audio = this.changeAudio(item.audio)
        return {
          img,
          audio
        }
      })
    },
    // 文音讲解类型数据处理
    initTextAudioExplainData () {
      let content
      try {
        content = JSON.parse(this.content)
      } catch (e) {
        console.log('JSON解析出错')
      }
      if (!content) return
      this.textAudioExplainData = content.map(item => {
        // 处理audio
        const audio = this.changeAudio(item.audio)
        // 处理文本text
        let text = this.changeImg(item.text)
        text = this.changeAudio(text)
        return {
          audio,
          text
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// packages/material-content/src/Content.vue